import React, {useState} from "react";
import {isEmpty} from "lodash";
import { Container, Row, Col } from "react-bootstrap";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Modal from 'react-bootstrap/Modal';
import Slider from "react-slick";
import $ from "jquery";

import TilesBox from "./Section/TilesBox";
import ContentModule from "../../modules/content_module";


import "./Tiles.scss";

const TilesBlock = ({Module, GQLPage}) => {

    const [show, setShow] = useState(false);
    const [showContent, setShowContent] = useState("");
    
    var animation_effect = Module.number_of_tiles === "one" ? "animate__fadeInLeftBig" : "animate__fadeInUp"
    var animation_delay = Module.number_of_tiles === "four" ? 4 : 3

    var imagename = (Module.number_of_tiles === "four" || Module.number_of_tiles === "three") ? "pages.tiles_box_component_image.small_tiles_image" : "pages.tiles_box_component_image.large_tiles_image"

    if(Module?.tiles_layout_type === "text_under_image"){
        imagename = Module.number_of_tiles === "four" ? "pages.tiles_box_component_image.four_tiles_image" :  Module.number_of_tiles === "three" ? "pages.tiles_box_component_image.three_tiles_image" : "pages.tiles_box_component_image.two_tiles_image"
    }

    if(Module?.tiles_layout_type === "card_layout"){
        imagename = "pages.tiles_box_component_image.card_layout"
    }

    var settings = {
        dots: false,
        arrows: Module?.tiles_module?.length > 4 ? true : false,
        infinite: false,
        speed: 500,
        slidesToShow: Module.number_of_tiles || 4,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed:5000,
        afterChange: (event) => {
            var activeDotEl = $('.service_tiles .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: Module?.tiles_module?.length > 3 ? true : false,
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    //console.log("Module ==>", Module)

    return (
        <React.Fragment>
            <section className={`tiles_section ${Module?.tiles_bg}`}>
                <Container>
                    <Row>
                        <Col>
                            <div className={`tiles-inner ${Module?.slider_enable ? "slider_wrapper" : ""} ${Module?.tiles_layout_type} ${Module?.tile_padd}`} id={Module.id}>

                                {(process.env.GATSBY_SITE_NAME === "D. J. Alexander" || process.env.GATSBY_SITE_NAME === "Linley and Simpson") ?
                                    <>
                                        {Module?.heading_text && <h2>{Module.heading_text}</h2>}
                                        {Module?.content && <p className="heading_content">{Module.content}</p>}
                                    </>
                                :
                                    Module?.title_content &&
                                    <>
                                        <ContentModule Content={Module?.title_content} />
                                    </>

                                }
                                {/* {Module?.title_content ?
                                    <>
                                        <ContentModule Content={Module?.title_content} />
                                    </>
                                    :
                                    <>
                                        {Module?.heading_text && <h2>{Module.heading_text}</h2>}
                                        {Module?.content && <p className="heading_content">{Module.content}</p>}
                                    </>
                                } */}
                                {/* {Module?.title_content &&
                                    <>
                                        <ContentModule Content={Module?.title_content} />
                                    </>                                    
                                } */}

                                <div className={`tiles-wrapper  ${Module?.number_of_tiles} ${Module?.tiles_overlay_color}`}>

                                    {Module?.slider_enable ?
                                        
                                        <Slider {...settings}>
                                            {Module.tiles_module.length > 0 && Module.tiles_module.map((item, index) => {

                                                let processedImages = JSON.stringify({});
                                                if (GQLPage?.imagetransforms?.tiles_box_component_image_Transforms) {
                                                    processedImages = GQLPage?.imagetransforms?.tiles_box_component_image_Transforms;
                                                }

                                                return(
                                                    <div className="slider_box">
                                                        <div className={`tiles_box ${item.popup_content ? "popup_content" : ""} ${(isEmpty(item?.title) && isEmpty(item?.content)) ? "height_auto" : "" }`}>

                                                            <TilesBox item={item} imagename={imagename} strapi_id={GQLPage.id} GQLPage={GQLPage} processedImages={processedImages} index={index} animation_effect={animation_effect} tiles_layout_type={Module?.tiles_layout_type} setShow={setShow} setShowContent={setShowContent}/>

                                                        </div>
                                                    </div>
                                                    )
                                                })

                                            }
                                        </Slider>
                                        :                                        
                                        Module.tiles_module.length > 0 && Module.tiles_module.map((item, index) => {

                                            let processedImages = JSON.stringify({});
                                            if (GQLPage?.imagetransforms?.tiles_box_component_image_Transforms) {
                                                processedImages = GQLPage?.imagetransforms?.tiles_box_component_image_Transforms;
                                            }

                                            return(
                                                <div className={`tiles_box ${item.popup_content ? "popup_content" : ""} ${(isEmpty(item?.title) && isEmpty(item?.content)) ? "height_auto" : "" }`}>

                                                        <TilesBox item={item} imagename={imagename} strapi_id={GQLPage.id} GQLPage={GQLPage} processedImages={processedImages} index={index} animation_effect={animation_effect} tiles_layout_type={Module?.tiles_layout_type} setShow={setShow} setShowContent={setShowContent}/>

                                                </div>


                                            )
                                        })
                                    } 
                                    
                                
                                </div>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Modal 
                className="tiles_popup"
                show={show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => {setShow(false); setShowContent("")}}
            >
                <Modal.Header closeButton>
                <Modal.Title>{showContent?.title}</Modal.Title></Modal.Header>
                <Modal.Body><ContentModule Content={showContent?.popup_content} /></Modal.Body>
            </Modal>

        </React.Fragment>
    );
};
export default TilesBlock;